import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "onChange", "defaultValue", "min", "max"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useEventCallback, useIsomorphicLayoutEffect } from '@cian/react-utils';
import { IMaskInput } from '../../../../internal/components/IMaskInput';
import { useControlled } from '../../../../internal/hooks';
import { invoke } from '../../../../internal/utils';
import { format } from '../../../../internal/utils/date';
import { IMASK_DATE_INPUT_OPTIONS } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const NativeDateMaskInput = /*#__PURE__*/React.forwardRef(function NativeDateMaskInput(props, ref) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
      as,
      onChange,
      defaultValue,
      min,
      max
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [dateValue, setDateValue] = useControlled({
    controlled: props.value,
    default: defaultValue !== undefined ? defaultValue : undefined
  });
  const [inputValue, _setInputValue] = React.useState(toStringValue(dateValue));
  const [inputAccepted, setInputAccepted] = React.useState(false);
  const setInputValue = useEventCallback(nextValue => {
    _setInputValue(nextValue);
  });
  useIsomorphicLayoutEffect(() => {
    const nextInputValue = toStringValue(dateValue);

    // чтобы при ручном стирании содержимое инпута не сбрасывалось
    if (!inputAccepted && inputValue !== nextInputValue) {
      setInputValue(nextInputValue);
    }
  }, [dateValue]);
  const handleInputAccept = (eventValue, inputMask) => {
    setInputAccepted(true);
    setInputValue(eventValue);
    const nextValue = inputMask.typedValue;
    setDateValue(nextValue);
    if (toStringValue(nextValue) !== toStringValue(dateValue)) {
      invoke(onChange, nextValue);
    }
  };
  const handleBlur = e => {
    setInputAccepted(false);
    const finalInputValue = toStringValue(dateValue);
    if (inputValue !== finalInputValue) {
      setInputValue(finalInputValue);
    }
    invoke(props.onBlur, e);
  };
  return /*#__PURE__*/_jsx(IMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    as: as,
    type: "tel",
    value: inputValue,
    options: IMASK_DATE_INPUT_OPTIONS,
    onAccept: handleInputAccept,
    onBlur: handleBlur,
    spellCheck: false
  }));
});
const INPUT_FORMAT = 'dd.MM.yyyy';
function toStringValue(value) {
  if (value instanceof Date) {
    return format(INPUT_FORMAT, value);
  }
  return '';
}